import { createContext, useContext, useEffect, useMemo, useReducer, useState } from "react";
import reducer from "./cart_reducer";
import { UseGlobellogin } from "../Logincontaxt.jsx/Logincontex";
import { BASE_URL } from "../../Config/Config";

const cartcontaxt = createContext();
const intialstate = {
    databasecartdata :[],  
     order_total:0,
}
// const User_id = localStorage.getItem("user_id");

const Cartprovider = ({children})=>{
    const [state , dispatch] = useReducer(reducer , intialstate);
    const {setsuccessfully , refresh , setrefresh , userId , seterrormessage } = UseGlobellogin();
    const [cartloading , setcartloading] = useState(true);
    const [loading , setloading ] =  useState(false);
    const [totalCartPrice , settotalCartPrice] = useState(0);


    const AddTocart = async (courseid) => {
        
        // if ( !singleCourse[0]?.id) {
        //     seterrormessage("Invalid course data.");
        //     setloading(false);
        //     return;
        // }
        try {
            setloading(true);
            const response = await fetch(`${BASE_URL}/add_to_cart/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    // course_id: singlecourseobj.id,
                    // course_id: singleCourse[0]?.id,
                    course_id: courseid,
                    quantity: 1 ,
                    user_id: userId,
                }),
            });
    
            if (!response.ok) {
                throw new Error("Failed to add to cart");
            }
    
            const result = await response.json();
            fetchCart(); 

        } catch (error) {
            console.error("Error adding item to cart:", error);
        }
        finally{
                    setloading(false);

        }
    };
    useEffect(() => {
        fetchCart();
    }, [refresh ,userId ]);

    const fetchCart = async () => {
  
        try {
        setcartloading(true);
            const response = await fetch(`${BASE_URL}/add_to_cart/?user_id=${userId}`);
            const result = await response.json();

            if (response.ok) {
                dispatch({ type: "CART_DATA", payload: result.data });     
                
            } else {
                console.error("Failed to fetch cart data:", result.message);
            }
        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
        finally{
                    setcartloading(false);

        }
    };

   const removeitem = async (id) => {
    try {
        const response = await fetch(`${BASE_URL}/add_to_cart/${id}/`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
        });
          const result = await response.json();
        if (response.ok) {
           fetchCart();
            setsuccessfully(result.message);
            setTimeout(() => setsuccessfully(""), 4000);
        } else {
            console.error("Failed to delete item:", result.message);
        }
    } catch (error) {
        console.error("Error deleting cart item:", error);
    }
};

const SetDecrease = async ( id , quantity ) => {
    if (quantity > 1) { 
        const newQuantity = quantity - 1; 

        try {
            const response = await fetch(`${BASE_URL}/add_to_cart/${id}/`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                     quantity: newQuantity,
                                                                       
                 }),
            });

            if (!response.ok) throw new Error("Failed to decrease quantity");
            const result = await response.json();
           fetchCart();
        } catch (error) {
            console.error("Error decreasing cart item:", error);
        }
    }

     else {
        console.log("Quantity cannot be less than 1");
    }
};
const SetIncrease = async (id, quantity ) => {
    const newQuantity = quantity + 1; // Increment quantity by 1
    try {
        const response = await fetch(`${BASE_URL}/add_to_cart/${id}/`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                              quantity: newQuantity ,
            }),
        });
        
        if (!response.ok) throw new Error("Failed to increase quantity");
        
        fetchCart(); 
        const result = await response.json();

        // Refresh the cart after updating
    } catch (error) {
        console.error("Error increasing cart item:", error);
    }
};

const clearCart = async(userId)=>{

    try {
        console.log("clearcrt",userId);
        const response = await fetch(`${BASE_URL}/Clearcart/${userId}`,{
               method: "DELETE",
        });
         const result = await response.json();

        if (response.ok) {
            console.log("Item removed:", result.message);
              fetchCart();

        } else {
            console.error("Failed to delete item:", result.message);
        }
    } catch (error) {
        console.error("Error deleting cart item:", error);
    } 
}

useEffect(()=>{
    settotalCartPrice (state.databasecartdata.reduce((acc, item) => acc + item.total_price, 0));
},[fetchCart])
   

useEffect(()=>{
  dispatch({type :"CART_TOTAL_PRICE"});
//   dispatch({type :"CART_TOTAL_PRICE"});
} , [state.cart]);


   return <cartcontaxt.Provider value={{...state , AddTocart , removeitem ,  SetDecrease  , SetIncrease , clearCart , cartloading ,totalCartPrice , loading }}> 
    {children}
   </cartcontaxt.Provider  >
};

const Usecartcontaxt = ()=>{
    return useContext(cartcontaxt);
}

export{ Cartprovider , Usecartcontaxt , cartcontaxt}